export var Head = function Head(props) {
  return false;
};
Head.mdxDeckHead = true;
export default Head;